"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsPickerRangeMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _NightsCounter = require("./NightsCounter");
var _MobileDropdown = require("../../MobileDropdown");
var _pluralizeUtils = require("../../../utils/pluralizeUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var NightsPickerRangeMobile = exports.NightsPickerRangeMobile = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var startNight = _ref.startNight,
    endNight = _ref.endNight,
    onChangeStartNight = _ref.onChangeStartNight,
    onChangeEndNight = _ref.onChangeEndNight,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 2 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 30 : _ref$maxValue;
  var _useState = (0, _react.useState)([startNight, endNight]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    defaultValues = _useState2[0],
    setDefaultValues = _useState2[1];
  var nights = startNight === endNight ? endNight : "".concat(startNight, "-").concat(endNight);
  var handleChangeStartNight = function handleChangeStartNight(val) {
    onChangeStartNight(val);
    if (val >= endNight) {
      onChangeEndNight(val + 1);
    }
  };
  var handleChangeEndtNight = function handleChangeEndtNight(val) {
    onChangeEndNight(val);
    if (val <= startNight) {
      onChangeStartNight(val - 1);
    }
  };
  var handleCancel = function handleCancel() {
    var _defaultValues = (0, _slicedToArray2["default"])(defaultValues, 2),
      start = _defaultValues[0],
      end = _defaultValues[1];
    onChangeStartNight(start);
    onChangeEndNight(end);
  };
  var handleSubmit = function handleSubmit() {
    var newDefaultNights = [startNight, endNight];
    setDefaultValues(newDefaultNights);
  };
  return /*#__PURE__*/_react["default"].createElement(_MobileDropdown.MobileDropdown, {
    onCancel: handleCancel,
    onSubmit: handleSubmit,
    popupLabel: "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C",
    dropdownLabel: "".concat(nights, " ").concat((0, _pluralizeUtils.pluralizeNights)(nights))
  }, /*#__PURE__*/_react["default"].createElement(CounterWrapper, null, "\u041E\u0442", /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
    value: startNight,
    onValueChange: handleChangeStartNight,
    minValue: minValue,
    maxValue: maxValue
  }), "\u0434\u043E", /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
    value: endNight,
    onValueChange: handleChangeEndtNight,
    minValue: minValue + 1,
    maxValue: maxValue - 1
  }), "\u043D\u043E\u0447\u0435\u0439"));
});
NightsPickerRangeMobile.displayName = 'NightsPickerRange';
var CounterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "NightsPickerRangemobile__CounterWrapper",
  componentId: "sc-1v0iar7-0"
})(["display:flex;align-items:center;justify-content:center;padding:0 8px;"]);